import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onSave: () => void
  onSaveLoading: boolean
  savingForm: boolean
  savingWorkflow: boolean
  onClose: () => void
}
const SaveRequestTypeModal = ({
  onSave,
  onClose,
  onSaveLoading,
  savingForm,
  savingWorkflow,
}: Props) => {
  return (
    <Modal
      illustration="input-field"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.save.title')}
      description={i18n.t('procurement.purchase_requests.settings.types.modals.save.description', {
        resources: [
          savingForm && i18n.t('procurement.purchase_requests.settings.types.modals.save.form'),
          savingWorkflow &&
            i18n.t('procurement.purchase_requests.settings.types.modals.save.workflow'),
        ]
          .filter(Boolean)
          .join(', '),
      })}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.save.buttons.cancel')}
          </Button>
          <Button onClick={onSave} disabled={onSaveLoading}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.save.buttons.save')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16"></Box>
    </Modal>
  )
}

export default SaveRequestTypeModal
